import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import {fetchPosts, ROUTER} from '../actions/index';

import Header from '../components/header';
import Main from '../components/main';
import Footer from '../components/footer';
import NavBar from './parts/NavBar';

class Blog extends Component {
    componentWillMount() {
        this.props.fetchPosts('posts');
        this.props.dispatch({
           type: ROUTER,
           payload: this.props.match
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.pageNum !== nextProps.match.params.pageNum || this.props.location.pathname !== nextProps.location.pathname) {
            this.props.fetchPosts('posts');
            this.props.dispatch({
                type: ROUTER,
                payload: nextProps.match
            });
        }
    }

    componentDidUpdate() {
        document.title = `${RT_API.siteName} - ${RT_API.siteDescription}`;
    }

    render() {
        return (
            <section className="kiosk-wrapper">
                <Typekit kitId="eab1tpm" />
                <Header/>
                <Main/>
				<NavBar name="footer_menu" />
            </section>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({fetchPosts, dispatch}), dispatch)
}

export default connect(null, mapDispatchToProps)(Blog)


// WEBPACK FOOTER //
// ./src/containers/blog.js